
$(function(){
  // ページ内リンク
  var pageLink=$('[href^="#"]');
  $(pageLink).click(function(){
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position=target.offset().top;
    $("html, body").animate({scrollTop:position}, 500, "swing");
    return false;
  });
  // スクロールアクション
  $(window).on('load scroll',function(){
    var scroll = $(window).scrollTop();
    var windowHeight = $(window).height();
    $('.scroll_action').each(function (){
        var This =$(this);
        var elemPos = This.offset().top;
        var w = $( window ).width() ;
        if(This.hasClass('bottom_action')){
          var triggerHeight = windowHeight*0.1;
        }else{
          var triggerHeight = windowHeight*0.25;
        }
        if (scroll > elemPos - windowHeight + triggerHeight){
          This.addClass('active');
        }else{
          This.removeClass('active');
        }
    });
  });


  // modal
    $('.img_list li').click(function(){
      var imgNum = $(this).data('img');
      $('.modal_bg').show();
      $('.modal_img img:nth-child('+imgNum+')').addClass('on');
      $('body').css('overflow','hidden');

      $('.modal_bg').click(function(){
        $(this).hide();
        $('.modal_img img').removeClass('on');
        $('body').css('overflow','auto');
      });
    });

});
